import { Box, Button } from '@mui/material'
import CustomerAccountsPaymentContainerMobile from './dialogs/CustomerAccountsSellPopup/CustomerAccountsPaymentMobile'
import usePaymentContext from './hook/usePaymentContext'
import CashMobilePayment from 'components/QuickSaleMobile/Dialog/PaymentDialogMobile/Cash/CashMobilePayment'
import EvoMobilePayment from 'components/QuickSaleMobile/Dialog/PaymentDialogMobile/Evo/EvoMobilePayment'
import CreditCardMobilePayment from 'components/QuickSaleMobile/Dialog/PaymentDialogMobile/CreditCard/CreditCardMobilePayment'
import CustomerAccountMobilePayment from 'components/QuickSaleMobile/Dialog/PaymentDialogMobile/CustomerAccount/CustomerAccountMobilePayment'
import { PAYMENT_TYPE_ID } from 'constant/paymentType'
import PaymentDialogMobileContent from 'components/QuickSaleMobile/Dialog/PaymentDialogMobile/PaymentDialogMobileContent'
import useSendPaymentToCFD from 'hooks/useSendMessageToCFD/useSendPaymentToCFD'
import { useEffect } from 'react'
import { PaymentDisplaySection } from './hook/SectionType'

export function PaymentMainSectionMobile({
    onBack,
    onSubmitPayment,
}: {
    onBack: () => void
    onSubmitPayment: () => void
}) {
    const {
        selectedPaymentType,
        currentSection,
        isSplitPayment,
        payment,
        expectAmount,
    } = usePaymentContext()
    const { sendAwaitingPaymentToCFS } = useSendPaymentToCFD()
    useEffect(() => {
        if (payment) sendAwaitingPaymentToCFS(expectAmount.toNumber(), payment)
    }, [expectAmount, payment, sendAwaitingPaymentToCFS])

    if (currentSection === PaymentDisplaySection.AccountList)
        return (
            <CustomerAccountsPaymentContainerMobile
                onBack={isSplitPayment ? onBack : undefined}
            />
        )
    return (
        <>
            {selectedPaymentType?.paymentTypeID === PAYMENT_TYPE_ID.CASH ? (
                <CashMobilePayment
                    onBack={onBack}
                    onSubmitPayment={onSubmitPayment}
                />
            ) : selectedPaymentType?.paymentTypeID ===
              PAYMENT_TYPE_ID.EVO_PAYMENT ? (
                <EvoMobilePayment
                    onBack={onBack}
                    onSubmitPayment={onSubmitPayment}
                />
            ) : selectedPaymentType?.paymentTypeID ===
              PAYMENT_TYPE_ID.CREDITCARD ? (
                <CreditCardMobilePayment
                    onBack={onBack}
                    onSubmitPayment={onSubmitPayment}
                />
            ) : selectedPaymentType?.paymentTypeID ===
              PAYMENT_TYPE_ID.CUSTOMER_ACCOUNT ? (
                <CustomerAccountMobilePayment
                    onBack={onBack}
                    onSubmitPayment={onSubmitPayment}
                />
            ) : (
                <PaymentDialogMobileContent
                    hidePaymentSelect
                    topSection={
                        <Box p={3}>Payment type not currently supported.</Box>
                    }
                    bottomSection={<></>}
                    finishButton={
                        <Button
                            fullWidth
                            variant="outlined"
                            color="primary"
                            onClick={onBack}
                        >
                            Back
                        </Button>
                    }
                ></PaymentDialogMobileContent>
            )}
        </>
    )
}
